import { ClientOfferState } from '@bd/client/types'

export const isLoadingChunk = (state?: ClientOfferState): boolean => {
  const isContentPresentBeforehand = !!state?.citiesAndProvinces.content
  return (
    (state?.citiesAndProvinces.isLoading ?? false) && isContentPresentBeforehand
  )
}

export const isLoadingFirstTime = (state?: ClientOfferState): boolean => {
  const isContentPresentBeforehand = !!state?.citiesAndProvinces.content
  return (
    (state?.citiesAndProvinces.isLoading ?? false) &&
    !isContentPresentBeforehand
  )
}

export const allCitiesLoaded = (state?: ClientOfferState): boolean => {
  const citiesContent = state?.citiesAndProvinces.content
  if (!citiesContent) {
    return false
  }
  return citiesContent.content.length >= citiesContent.totalCount
}

export const getNextPageIndex = (state?: ClientOfferState) => {
  const citiesContent = state?.citiesAndProvinces.content
  return citiesContent != null ? citiesContent.pageNumber + 1 : 0
}
